import React, { useState } from 'react';
import './ExpertiseTypeStep.css';

const expertiseCategories = [
  {
    id: 'skills',
    icon: '💡',
    title: 'Skills & Talents',
    description: 'Share your professional or creative skills'
  },
  {
    id: 'mentorship',
    icon: '🎯',
    title: 'Mentorship',
    description: 'Guide others in their career or personal development'
  },
  {
    id: 'coaching',
    icon: '🎓',
    title: 'Coaching',
    description: 'Provide specialized coaching in your field'
  },
  {
    id: 'consulting',
    icon: '💼',
    title: 'Consulting',
    description: 'Offer expert advice and consulting services'
  }
];

const ExpertiseTypeStep = ({ onNext, onBack, onDataUpdate, data }) => {
  const [selectedType, setSelectedType] = useState(data.expertiseType || '');

  const handleSelect = (typeId) => {
    setSelectedType(typeId);
    onDataUpdate({ expertiseType: typeId });
  };

  return (
    <div className="expertise-type-step">
      <h1>What type of expertise will you share?</h1>
      <p className="subtitle">Choose the category that best describes your offering</p>
      
      <div className="expertise-grid">
        {expertiseCategories.map((category) => (
          <button
            key={category.id}
            className={`expertise-card ${selectedType === category.id ? 'selected' : ''}`}
            onClick={() => handleSelect(category.id)}
          >
            <span className="expertise-icon">{category.icon}</span>
            <h3>{category.title}</h3>
            <p>{category.description}</p>
          </button>
        ))}
      </div>

      <div className="step-actions">
        <button 
          className="next-button"
          onClick={onNext}
          disabled={!selectedType}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ExpertiseTypeStep; 